export default {
  confirmDelete: {
    header: 'Usunąć parametr "{parameter}" zasobu "{asset}"?',
    message: 'Zamiast tego obowiązuje wartość najbliższego zasobu nadrzędnego lub, jeśli żaden jej nie definiuje, wartość domyślna.',
  },
};
